/**
 * The knowledge library's document categories, labelled in the active
 * language. Config-driven (app.yaml `knowledge_base.categories`); empty until
 * /config has loaded.
 */
import { useMemo } from 'react'
import { useActiveLanguage, useConfigStore } from '@ai4nr/tricorder-ui'

import { knowledgeBaseCategories } from '@/api/config'
import type { DocumentCategory } from '@/api/documents'

export interface KnowledgeCategoryOption {
  value: DocumentCategory
  label: string
}

export function useKnowledgeCategories(): KnowledgeCategoryOption[] {
  const config = useConfigStore((s) => s.config)
  const lang = useActiveLanguage()
  return useMemo(
    () =>
      knowledgeBaseCategories(config).map((c) => ({
        value: c.key,
        label: lang === 'de' ? c.label_de : c.label_en,
      })),
    [config, lang],
  )
}
